/* eslint-disable check-file/filename-blocklist */
/**
 * Stickytable headers for confluence
 */

// eslint-disable-next-line no-restricted-imports
import $ from 'jquery';

/**
 * isNotAlreadyEnabled - is table already enabled
 *
 * @param {JqueryHTMLElement} table jquery table element
 * @return {Boolean}
 */
const isNotAlreadyEnabled = function ($table) {
	return !$table.hasClass('stickyTableHeaders');
};

/**
 * isNotNestedTable - is table inside a nested table
 *
 * @param {JqueryHTMLElement} table jquery table element
 * @return {Boolean}
 */
const isNotNestedTable = function ($table) {
	return !$table.parents('table').length > 0;
};

/**
 * isTheadDirectVisibleChild - is thead present as the visible direct child of a table
 *
 * @param {JqueryHTMLElement} table jquery table element
 * @return {Boolean}
 */
const isTheadDirectVisibleChild = function ($table) {
	return $table.find('> thead:first').is(':visible');
};

/**
 * hasTheadGotOnlyOneChild - Do we have only a single row inside the thead
 *
 * This will fix problems when people copy tables from the viewpage inside the editor and
 * add extra rows after the header. We should not enable sticky headers on tables that have more than
 * one TR inside the Thead
 *
 * @param {JqueryHTMLElement} table jquery table element
 * @return {Boolean}
 */
const hasTheadGotOnlyOneChild = function ($table) {
	return $table.find('thead').children().length === 1;
};

/**
 * isNotInsidePageLayout - is table inside a page layouts
 *
 * @param {JqueryHTMLElement} table jquery table element
 * @return {Boolean}
 */
const isNotInsidePageLayout = function ($table) {
	return !$table.closest('.columnLayout').length > 0;
};

/**
 * isNotDocumentationTheme
 *
 * Documentation theme is incompatible with stickyheaders
 *
 * @param {JqueryHTMLElement} table jquery table element
 * @return {Boolean}
 */
const isNotDocumentationTheme = function () {
	return !$('body').hasClass('theme-documentation');
};

/**
 * areAllConfluenceThInTheSameRow - confluenceTh on different rows should be disabled
 *
 * We don't support vertical headers
 *
 * @param {JqueryHTMLElement} table jquery table element
 * @return {Boolean}
 */
const areAllConfluenceThInTheSameRow = function ($table) {
	return $table.find('.confluenceTh').parent().length === 1;
};

/**
 * areAllAdjacentCellsConfluenceTh - All cells in the same row needs to be confluenceTh
 *
 * Stickyheaders should only be applied if all cells are headers to avoid scrolling without
 * background problems
 *
 * @param {JqueryHTMLElement} table jquery table element
 * @return {Boolean}
 */
const areAllAdjacentCellsConfluenceTh = function ($table) {
	return $table.find('.confluenceTh').siblings().hasClass('confluenceTh');
};

/**
 * isAValidTable - Check if an html table can be used for sticky headers
 *
 * @param {HTMLElement} table HTMLElement
 * @return {Boolean} is a valid table element for stickyheaders
 */
const isAValidTable = function (table) {
	const $table = $(table);

	return (
		isNotDocumentationTheme() &&
		isNotAlreadyEnabled($table) &&
		isNotInsidePageLayout($table) &&
		isNotNestedTable($table) &&
		isTheadDirectVisibleChild($table) &&
		hasTheadGotOnlyOneChild($table) &&
		areAllConfluenceThInTheSameRow($table) &&
		areAllAdjacentCellsConfluenceTh($table)
	);
};

/**
 * CONFDEV-33100 - The sticky headers library re-renders the sticky header if the window scrolls but not if you scroll
 * inside the table-wrap div, which is required for horizontal scrolling
 *
 * @param {JqueryHTMLTableElement} $tables tables to bind the scroll event to
 * @param {JqueryHTMLWindowElement} $win window to trigger the scroll event
 */
const bindHorizontalScrolling = function ($tables, $win) {
	const $window = $win || $(window);

	$tables.closest('.table-wrap').scroll(() => {
		$window.trigger('scroll.stickyTableHeaders');
	});
};

/**
 * moveHeaderRowsToTHead - Moves first row confluence th to a thead
 *
 * @param {HTMLTableElement|JqueryHTMLTableElement} table Html table element
 */
const moveHeaderRowsToTHead = function (table) {
	$(table).each(function () {
		const $thisTable = $(this);
		const hasMergedColumns = $thisTable.find('.confluenceTh[rowspan]').length > 0;
		const $th = $thisTable.find('> :first-child > :first-child .confluenceTh');
		const alredyWrappedOnAThead = $th.length && $th.closest('thead').length > 0;
		const isFirstRow = $th.length && $th.parent().index() === 0;

		// we don't have a thead, so lets create one, but only if the confluenceTh are the first tr
		if (
			isNotNestedTable($thisTable) &&
			isNotInsidePageLayout($thisTable) &&
			!alredyWrappedOnAThead &&
			isFirstRow &&
			!hasMergedColumns
		) {
			// move to a thead
			const $headerElement = $('<thead />').append($th.parent());

			$thisTable.prepend($headerElement);
		}
	});
};

export default {
	isAValidTable,
	bindHorizontalScrolling,
	moveHeaderRowsToTHead,
	isNotDocumentationTheme,
};
